import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.css";
import Skeleton from "../../../components/Skeleton";
import NoResultsFound from "../../../components/NoResultsFound";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../../components/Pagination";
import DropdownwithValue from "../../../components/DropdownValue";
import { getPayments } from "../../../redux/features/payments/paymentService";
import SearchBar from "../../../components/SearchBar";

const recurringList = [
    { id: '1', name: 'Subscription' },
    { id: '2', name: 'One Time' },
];

const statusList = [
    { id: '1', name: 'Pending' },
    { id: '2', name: 'Completed' },
];

const Payments = () => {
    const dispatch = useDispatch();
    const recurringDropdownRef = useRef(null);
    const statusDropdownRef = useRef(null);

    const { isPaymentsLoading, pageCount, payments } = useSelector(
        (state) => state.payment.payments
    );

    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [recurringValue, setRecurringValue] = useState(null);
    const [isRecurring, setRecurring] = useState(false);
    const [statusValue, setStatusValue] = useState(null);
    const [isStatus, setStatus] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [skip, setSkip] = useState(1);
    const limit = 25;

    const filterAllPayments = useCallback(
        (filters = {}) => {
            const params = {
                skip: skip,
                limit: limit,
                created_from: dateFrom,
                created_to: dateTo,
                is_recurring: isRecurring && recurringValue.name,
                order_status: isStatus && statusValue.name,
                payment_id: searchQuery,
                ...filters,
            };
            dispatch(getPayments(params));
        },
        [dispatch, skip, dateFrom, dateTo, recurringValue, statusValue, searchQuery]
    );

    useEffect(() => {
        filterAllPayments();
    }, [filterAllPayments]);

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber);
    };

    const handleRecurring = (option) => {
        setRecurring(true);
        setRecurringValue(option);
        setSkip(1);
    };

    const handleStatus = (option) => {
        setStatus(true);
        setStatusValue(option);
        setSkip(1);
    };

    const clearAll = () => {
        setSkip(1);
        setStatus(false);
        setRecurring(false);
        setSearchQuery('');
        setRecurringValue(null);
        setStatusValue(null);
        setDateFrom();
        setDateTo();
        if (recurringDropdownRef.current) recurringDropdownRef.current.clearSelection();
        if (statusDropdownRef.current) statusDropdownRef.current.clearSelection();
    }

    return (
        <>
            <div className={`card-section`} style={{ marginTop: '20px' }}>
                <div className={`search-card`}>
                    <div className={`search-card-header`} style={{ flexDirection: 'column' }}>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col`}>
                                <h1 className={`form-title ${styles.headDiv}`}>
                                    Payments List
                                </h1>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Date From
                                    </label>
                                    <input
                                        type="date"
                                        value={dateFrom || ''}
                                        onChange={(e) => { setDateFrom(e.target.value); setSkip(1) }}
                                        className={`form-input-default`}
                                        placeholder="Draw Number"
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label ${styles.formLableMobile}`}>
                                        Date To
                                    </label>
                                    <input
                                        type="date"
                                        value={dateTo || ''}
                                        onChange={(e) => { setDateTo(e.target.value); setSkip(1) }}
                                        className={`form-input-default`}
                                        placeholder="Draw Number"
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label ${styles.formLableMobile}`}>
                                        Recurring
                                    </label>
                                    <DropdownwithValue
                                        ref={recurringDropdownRef}
                                        options={recurringList}
                                        placeholder='Select a Type'
                                        onSelect={handleRecurring}
                                        value={recurringValue?.name}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row ${styles.searchRow}`}>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Payment Status
                                    </label>
                                    <DropdownwithValue
                                        ref={statusDropdownRef}
                                        options={statusList}
                                        placeholder='Select a Status'
                                        onSelect={handleStatus}
                                        value={statusValue?.name}
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label ${styles.formLableMobile}`}>
                                        Payment Id
                                    </label>
                                    <SearchBar onSearch={(query) => setSearchQuery(query)} />
                                </div>
                            </div>
                            <button
                                className={`btn-primary`}
                                type='button'
                                style={{height: '49px', marginTop: '25px'}}
                                onClick={clearAll}>
                                <FontAwesomeIcon icon={faRefresh} />
                            </button>
                        </div>
                    </div>
                    <div className={`search-card-body`}>
                        {isPaymentsLoading ? (
                            <Skeleton
                                columns={["Payment Id", "Customer", "Payment Method", "Is Recurring", "Status", "Currency", "Amount"]}
                                rowCount={10}
                                height={20}
                            />
                        ) : payments.length > 0 ? (
                            <div className={`table-container`}>
                                <table className={`table`}>
                                    <thead className={`thead`}>
                                        <tr>
                                            <th className={`theadColumnOne`}>Payment Id</th>
                                            <th>Customer</th>
                                            <th>Payment Method</th>
                                            <th>Is Recurring</th>
                                            <th>Status</th>
                                            <th>Currency</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody className={`tbody`}>
                                        {payments?.map((payment) => (
                                            <tr key={payment.id}>
                                                <td className={`tdataColumnOne`}>{payment.payment_id}</td>
                                                <td>{payment.order.user.username}</td>
                                                <td>{payment.method}</td>
                                                <td>{payment.is_recurring ? `Recurring` : `One Time`}</td>
                                                <td>{payment.order_status}</td>
                                                <td>{payment.currency}</td>
                                                <td>{payment.amount.toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <NoResultsFound />
                        )}
                    </div>
                    <div className={`search-card-footer`}>
                        {pageCount > 0 && (
                            <div className={styles.paginationContainer}>
                                <Pagination
                                    currentPage={skip}
                                    totalPages={pageCount}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div >
        </>
    );
};

export default Payments;
